import styles from '../select.module.css';

import { ArrowDownIcon } from '../../../helpers/icons';
import closeIcon from 'assets/svg/close-01.svg';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../Icon';
import Tooltip from '../../Tooltip';

const SelectValue = ({
  selectedOptions,
  titleKey,
  toggleDropdown,
  handleClear,
  placeholder,
  renderValue,
  multiple,
  selectedValues,
  valueKey,
  clearable,
  arrowColor,
  isOpen,
  disabled,
}) => {
  // Отображение выбранного значения
  const getSelectedLabels = () => {
    if (selectedValues.length === 0) {
      return placeholder;
    }

    if (renderValue) {
      return renderValue(
        multiple ? selectedValues : selectedValues[0],
        selectedOptions,
        valueKey,
        titleKey,
      );
    }

    if (selectedOptions.length === 0) {
      return placeholder;
    }

    return selectedOptions.map((option) => option[titleKey]).join(', ');
  };

  return (
    <div className={styles.selectValue} onClick={toggleDropdown}>
      <div className={styles.valueText}>{getSelectedLabels()}</div>
      <div className={styles.actions}>
        {clearable && !disabled && selectedValues.length > 0 && (
          <Tooltip text={'Очистить'}>
            <Icon
              className={styles.clearIcon}
              src={closeIcon}
              width={12}
              height={8}
              onClick={handleClear}
            />
          </Tooltip>
        )}
        <Icon
          src={ArrowDownIcon}
          width={12}
          height={8}
          aria-hidden="true"
          color={arrowColor}
          className={classNames(styles.arrow, { [styles.open]: isOpen })}
        />
      </div>
    </div>
  );
};

SelectValue.propTypes = {
  selectedOptions: PropTypes.array.isRequired,
  titleKey: PropTypes.string.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired,
  notSelectedText: PropTypes.string,
  placeholder: PropTypes.string,
  renderValue: PropTypes.func,
  multiple: PropTypes.bool.isRequired,
  selectedValues: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  clearable: PropTypes.bool.isRequired,
  arrowColor: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default SelectValue;
